import React, { useId } from "react";

// Small flag artwork for the language picker, keyed by language code. Inline
// SVG rather than emoji because Windows doesn't render flag emoji.

const UnitedKingdom = () => {
  // Clip-path ids must be unique per instance on the page.
  const id = useId();
  return (
    <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice">
      <clipPath id={`${id}s`}>
        <path d="M0,0 v30 h60 v-30 z" />
      </clipPath>
      <clipPath id={`${id}t`}>
        <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
      </clipPath>
      <g clipPath={`url(#${id}s)`}>
        <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
        <path
          d="M0,0 L60,30 M60,0 L0,30"
          clipPath={`url(#${id}t)`}
          stroke="#C8102E"
          strokeWidth="4"
        />
        <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
        <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
      </g>
    </svg>
  );
};

const France = () => (
  <svg viewBox="0 0 3 2" preserveAspectRatio="xMidYMid slice">
    <rect width="1" height="2" fill="#002654" />
    <rect x="1" width="1" height="2" fill="#fff" />
    <rect x="2" width="1" height="2" fill="#CE1126" />
  </svg>
);

const Spain = () => (
  <svg viewBox="0 0 3 2" preserveAspectRatio="xMidYMid slice">
    <rect width="3" height="2" fill="#AA151B" />
    <rect y="0.5" width="3" height="1" fill="#F1BF00" />
  </svg>
);

const Germany = () => (
  <svg viewBox="0 0 5 3" preserveAspectRatio="xMidYMid slice">
    <rect width="5" height="1" fill="#000" />
    <rect y="1" width="5" height="1" fill="#DD0000" />
    <rect y="2" width="5" height="1" fill="#FFCE00" />
  </svg>
);

const SouthAfrica = () => (
  <svg viewBox="0 0 90 60" preserveAspectRatio="xMidYMid slice">
    <rect width="90" height="30" fill="#E03C31" />
    <rect y="30" width="90" height="30" fill="#001489" />
    <path d="M0,0 L45,30 L0,60 M45,30 H90" stroke="#fff" strokeWidth="20" />
    <path d="M0,0 L45,30 L0,60 M45,30 H90" stroke="#007749" strokeWidth="12" />
    <path d="M0,9 L31,30 L0,51 z" fill="#FFB81C" />
    <path d="M0,15 L22,30 L0,45 z" fill="#000" />
  </svg>
);

export const FLAGS = {
  en: UnitedKingdom,
  fr: France,
  es: Spain,
  de: Germany,
  af: SouthAfrica,
};

// Circular flag for a language; falls back to the language code if there is
// no artwork for it yet.
export const LanguageFlag = ({ code, size = 20 }) => {
  const Flag = FLAGS[code];
  return (
    <span
      aria-hidden="true"
      className="ring-black/5 inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-[#F3F4F6] text-[9px] font-semibold uppercase text-[#6B7280] ring-1 [&>svg]:h-full [&>svg]:w-full"
      style={{ width: size, height: size }}
    >
      {Flag ? <Flag /> : code}
    </span>
  );
};
